import React from 'react';
export function HIPAA() {
  return <div className="bg-white min-h-screen py-20" data-id="element-242">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-243">
        <h1 className="text-4xl font-black text-slate-900 mb-8 uppercase tracking-tighter" data-id="element-244">
          HIPAA Notice
        </h1>
        <div className="prose prose-slate max-w-none space-y-6 text-slate-600 leading-relaxed" data-id="element-245">
          <p className="text-lg font-medium text-slate-900" data-id="element-246">
            Notice of Privacy Practices
          </p>
          <p data-id="element-247">
            This notice describes how medical information about you may be used
            and disclosed and how you can get access to this information. Please
            review it carefully.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-248">
            Our Legal Duty
          </h2>
          <p data-id="element-249">
            We are required by applicable federal and state law to maintain the
            privacy of your health information. We are also required to give you
            this notice about our privacy practices, our legal duties, and your
            rights concerning your health information.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-250">
            Uses and Disclosures of Health Information
          </h2>
          <p data-id="element-251">
            We use and disclose health information about you for treatment,
            payment, and healthcare operations. For example, we may disclose
            your health information to a physician or other healthcare provider
            providing treatment to you.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-252">
            Your Rights
          </h2>
          <p data-id="element-253">
            You have the right to look at or get copies of your health
            information, with limited exceptions. You also have the right to
            request that we amend your health information or place additional
            restrictions on our use or disclosure of your health information.
          </p>
        </div>
      </div>
    </div>;
}